import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor() { }

  public getToken(): string {
    return localStorage.getItem("_tnu") || "¯＼_(ツ)_/¯ you don't have a token!";
  }
}
